import { AreaItemPack } from '../models/area-item-pack';
import { AreaItem } from '../models/area-item';
import { BookingSlot } from '../models/booking-slot';
import { TimeRestriction } from '../models/time-restriction';
import { Product } from '../../order/models/product';


export class BookingInMemoryAreaItemGenerator {
  private _areaItemPacks: AreaItemPack[] = [
    new AreaItemPack(1, 'Open Fly', '60-120 Minuten<br/>für alle', 'Wähle einfach ein Flugdatum und die gewünschte Flugzeit aus und schon kann es losgehen. Bereit zum Abheben? LET‘S GO FLY!', 'assets/svg/symbols/single.svg', false, null, ''),
    new AreaItemPack(2, 'Kids Fly', 'Jeden Sa. & So | 9 - 10 Uhr<br/>60 Minuten<br/>Nur Eltern mit Kinder bis 6 J.', 'Jeden Samstag und Sonntag von 09:00 – 10:00 Uhr öffnen wir unsere Gates ausschließlich für unsere jüngeren Passagiere bis einschließlich 8 Jahre. ', 'assets/svg/symbols/kidsjump.svg', false, null, ''),
    new AreaItemPack(3, 'Friday Night', 'jeden Frietag | 20 - 23 Uhr<br/>ab 16 Jahren', 'Lights go down, music goes up! Freitags von 20:00 – 23:00 Uhr bieten wir Euch eine besondere Flugerfahrung in Clubatmosphäre, am letzten Freitag des Monats auch mit Live-DJ!', 'assets/svg/symbols/fridaynight.svg', false, null, ''),
    new AreaItemPack(4, 'Events', 'JGA<br/>Geburtstag<br/>Veranstalltung', null, 'assets/svg/symbols/event.svg', false, null, ''),
    new AreaItemPack(5, 'Events', 'JGA<br/>Geburtstag<br/>Veranstalltung', null, 'assets/svg/symbols/event.svg', true, null, 'birthday')
  ];

  private _additionalProductsIds: number[] = [300, 301];

  private _templateAreaItems = [
    new AreaItem(0, 0, 0, 'Erwachsene', 'Familie', 'ab 3 Personen', 'pro Familie', 0, 60, 9.50, 0.19, 0, null, false, false, false, null, this._additionalProductsIds, null, 1, null, null, 0, 0),
    new AreaItem(0, 0, 0, 'Kinder', 'Familie', 'ab 3 Personen', 'pro Familie', 0, 60, 9.50, 0.19, 0, null, false, false, false, null, this._additionalProductsIds, null, 2, null, null, 0, 0),
    new AreaItem(0, 0, 0, 'Normal', null, 'für jung und alt', 'pro Person', 0, 60, 12.00, 0.19, 0, null, false, false, false, null, this._additionalProductsIds, null, 3, null, null, 0, 0),
    new AreaItem(0, 0, 0, 'Behindert', null, 'ab GdB 50', 'pro Person', 0, 60, 6.00, 0.19, 0, null, false, false, false, null, null, null, 4, null, null, 0, 0),
  ];

  private _templateKidsAreaItems = [
    new AreaItem(0, 0, 0, 'Normal', null, 'für jung und alt', 'pro Person', 0, 60, 12.00, 0.19, 660, 'Kids Normal 60 min', false, false, false, null, this._additionalProductsIds, null, 5, null, null, 0, 0),
    new AreaItem(0, 0, 0, 'Behindert', null, 'ab GdB 50', 'pro Person', 0, 60, 6.00, 0.19, 661, 'Kids Behindert 60 min', false, false, false, null, this._additionalProductsIds, null, 6, null, null, 0, 0),
  ];

  private _templateFridayNightAreaItems = [
    new AreaItem(0, 0, 0, 'Normal', null, 'für jung und alt', 'pro Person', 0, 90, 24.00, 0.19, 662, 'Friday Night Normal 90 min', false, false, false, null, this._additionalProductsIds, null, 7, null, null, 0, 0),
    new AreaItem(0, 0, 0, 'Behindert', null, 'ab GdB 50', 'pro Person', 0, 90, 12.00, 0.19, 663, 'Friday Night Behindert 90 min', false, false, false, null, this._additionalProductsIds, null, 8, null, null, 0, 0),
  ];

  private _eventTableAreas = [200, 201, 202, 203, 204];

  private _templateEventAreaItems = [
    new AreaItem(101, 0, 4, 'JGA', null, null, null, 0, 90, 24.00, 0.19, 664, 'JGA', true, false, false, this._eventTableAreas, this._additionalProductsIds, null, 9, null,
      null, 0, 0),
    new AreaItem(102, 0, 4, 'Party', null, null, null, 0, 90, 24.00, 0.19, 665, 'Party', true, false, false, this._eventTableAreas, this._additionalProductsIds, null, 10, null,
      null, 0, 0),
    new AreaItem(103, 0, 4, 'Birthday', null, null, null, 0, 90, 24.00, 0.19, 666, 'Birthday', true, false, false, this._eventTableAreas, this._additionalProductsIds, null, 11, null,
      null, 0, 0),
  ];


  private _lastGeneratedProductId = 0;

  private _areaItemsCache: Map<number, AreaItem[]>;

  get areaItemPacks(): AreaItemPack[] {
    if (this._areaItemsCache == null) {
      this._generateAreaItemsCache();
    }

    return this._areaItemPacks;
  }

  getAreaItems(areaItemPackId: number): AreaItem[] {
    if (this._areaItemsCache == null) {
      this._generateAreaItemsCache();
    }

    return this._areaItemsCache.get(areaItemPackId);
  }

  private _generateAreaItemsCache(): void {
    this._areaItemsCache = new Map<number, AreaItem[]>();

    if (!this._areaItemPacks) {
      return;
    }

    this._lastGeneratedProductId = 1;

    this._areaItemPacks.forEach((areaItemPack, index) => {
      let areaItems: AreaItem[];

      switch (areaItemPack.name) {
        case `Kids Fly`:
          areaItems = this._templateKidsAreaItems;
          break;
        case `Friday Night`:
          areaItems = this._templateFridayNightAreaItems;
          break;
        case `Events`:
          areaItems = this._templateEventAreaItems;
          break;
        default:
          areaItems = this._generateAreaItems(areaItemPack, this._templateAreaItems, [60, 90, 120]);
          break;
      }

      this._areaItemsCache.set(areaItemPack.id, areaItems);
      areaItemPack.areaItems = areaItems;
    });
  }

  private _generateAreaItems(areaItemPack: AreaItemPack, templateAreaItems: AreaItem[], productTimeSpans: number[]): AreaItem[] {
    const packName = areaItemPack.name.substring(0, 3);
    const areaItems = Array<AreaItem>();

    for (const areaItem of templateAreaItems) {
      productTimeSpans.forEach((timeSpan, index2) => {
        const price = (index2 + 1) * areaItem.price;
        const price_description = this._buildInfoHtml(price, `${areaItem.priceDescription}`);
        areaItems.push(new AreaItem(
          this._lastGeneratedProductId,
          0,
          areaItemPack.id,
          areaItem.name,
          areaItem.group,
          areaItem.description,
          price_description,
          areaItem.itemQuantity,
          timeSpan,
          price,
          areaItem.taxRate,
          this._lastGeneratedProductId,
          `Open Jump ${areaItem.name} ${timeSpan} min`,
          false,
          false,
          false,
          null,
          areaItem.additionalProductIds,
          areaItem.automaticAdditionalProductsIds,
          areaItem.sequence,
          null,
          null,
          0,
          0,
        ));
        this._lastGeneratedProductId++;
      });
    }

    return areaItems;
  }

  private _buildInfoHtml(price: number, info: string): string {
    return `<div class="info">ab <span class="price">${price.toFixed(2).replace('.', ',')} €</span></div>
      <div class="info">${info}</div>`;
  }
}
